<div class='guest-container' [formGroup]='vehicle' >
  <app-loading size="0.5" class="loading-spinner" *ngIf="load else wrapper" color="var(--primary-sec-color)"></app-loading>
  <ng-template #wrapper>
      <div class='choose-options'>
        <div class='guest-dropdown'>
          <mat-form-field appearance="outline" class='year'>
            <mat-label>{{ 'vehicleManagement.source' | translate}}</mat-label>
            <mat-select formControlName="source" required>
              <mat-option *ngFor="let source of sources" [value]="source">{{source}}</mat-option>
            </mat-select>
            <mat-error *ngIf="f.source.invalid">{{'testDrive.pleaseSelectASource' | translate}}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class='year'
          [ngClass]="{'disabled' : !makeList?.length}">
            <mat-label>{{ 'service.make' | translate}}</mat-label>
            <mat-select formControlName="make" required>
              <mat-option *ngFor="let make of makeList" [value]="make">{{make}}</mat-option>
            </mat-select>
            <mat-error *ngIf="f.make.invalid && makeList?.length">{{'testDrive.pleaseSelectAMake' | translate}}</mat-error>
            <mat-hint *ngIf="!!f.make.value && !makeList?.length">{{'testDrive.noMakesForTheSource' | translate}}</mat-hint>
          </mat-form-field>
          
          <mat-form-field appearance="outline" class='model'
          [ngClass]="{'disabled' : !modelList?.length}">
            <mat-label>{{ 'testDrive.model' | translate}}</mat-label>
            <mat-select formControlName="model" required>
              <mat-option *ngFor="let model of modelList" [value]="model">{{model}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="f.model.invalid">{{'testDrive.pleaseSelectAModel' | translate}}</mat-error>
            <mat-hint *ngIf="!!f.model.value && !modelList?.length">{{'testDrive.noModlesForTheMake' | translate}}</mat-hint>
          </mat-form-field>

          <mat-form-field appearance="outline" class='year'
          [ngClass]="{'disabled' : !yearList?.length}">
            <mat-label>{{ 'testDrive.year' | translate}}</mat-label>
            <mat-select formControlName="year" required>
              <mat-option *ngFor="let year of yearList" [value]="year">{{year}}</mat-option>
            </mat-select>
            <mat-error *ngIf="f.year.invalid">{{'testDrive.pleaseSelectAYear' | translate}}</mat-error>
            <mat-hint *ngIf="!!f.year.value && !yearList?.length">{{'testDrive.noYearsForTheModel' | translate}}</mat-hint>
          </mat-form-field>
</div>
